import { render, staticRenderFns } from "./RootSystemGate.vue?vue&type=template&id=05649114&"
import script from "./RootSystemGate.vue?vue&type=script&lang=js&"
export * from "./RootSystemGate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports